<template>
  <div class="loading-overlay" v-if="loading">
    <div class="loading-spinner">
      <b-spinner variant="primary" label="Loading..."></b-spinner>
      <p class="mt-2">{{ message }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadingState',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: 'Loading...'
    }
  }
}
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  text-align: center;
}
</style>
